import React, { useState, useEffect } from "react";
import api from "@/services/api";
import { Crown, ChevronRight } from "lucide-react";

export const ClubProgresoCard = ({ telefono }) => {
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    if (!telefono || telefono.replace(/\D/g, "").length < 10) return;
    api.get(`/club/consultar/${encodeURIComponent(telefono)}`).then((r) => {
      if (r.data.reconocido) setDatos(r.data);
    }).catch(() => {});
  }, [telefono]);

  if (!datos) return null;

  const disponibles = (datos.beneficios || []).filter((b) => b.estado === "disponible");

  return (
    <div className="bg-gradient-to-br from-[#4A2C0A] to-[#5d3a10] rounded-2xl p-4 text-left text-amber-50" data-testid="club-progreso-card">
      <div className="flex items-center gap-2 mb-2">
        <Crown className="w-4 h-4 text-[#C8902A]" />
        <p className="text-sm font-bold">Club de la Abuela</p>
      </div>
      {datos.nivel_actual ? (
        <p className="text-sm">{datos.nivel_actual.emoji} ¡{datos.nombre_pila ? `${datos.nombre_pila}, ya` : "Ya"} eres <strong>{datos.nivel_actual.nombre}</strong>!</p>
      ) : (
        <p className="text-sm">¡{datos.nombre_pila ? `${datos.nombre_pila}, con` : "Con"} esta compra entras al club! 💛</p>
      )}
      {disponibles.length > 0 && (
        <p className="text-xs text-[#e0b050] mt-1.5">🎁 Tienes {disponibles.length === 1 ? "un beneficio disponible" : `${disponibles.length} beneficios disponibles`}: {disponibles[0].recompensa?.descripcion}</p>
      )}
      {datos.siguiente_nivel && datos.progreso && (
        <div className="mt-2.5">
          <div className="flex justify-between text-[10px] text-amber-200 mb-1">
            <span>Próximo: {datos.siguiente_nivel.emoji} {datos.siguiente_nivel.nombre}</span>
            <span>{datos.progreso.compras_actuales}/{datos.progreso.compras_meta} compras</span>
          </div>
          <div className="h-2 bg-white/15 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#C8902A] to-[#e0b050] rounded-full" style={{ width: `${datos.progreso.pct}%` }} />
          </div>
          {datos.progreso.faltan_compras > 0 && (
            <p className="text-[10px] text-amber-200 mt-1">Te {datos.progreso.faltan_compras === 1 ? "falta 1 compra" : `faltan ${datos.progreso.faltan_compras} compras`} para: {datos.siguiente_nivel.recompensa_descripcion}</p>
          )}
        </div>
      )}
      <a href="/club" data-testid="club-progreso-link" className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-[#C8902A] bg-[#C8902A]/15 hover:bg-[#C8902A]/30 px-3 py-1.5 rounded-full transition-colors">
        Ver mi club <ChevronRight className="w-3 h-3" />
      </a>
    </div>
  );
};

export default ClubProgresoCard;
